export const fontFamily = {
  thin: "NotoSansDevanagari-Thin",
  semiBold: "NotoSansDevanagari-SemiBold",
  medium: "NotoSansDevanagari-Medium",
  light: "NotoSansDevanagari-Light",
  extraLight: "NotoSansDevanagari-ExtraLight",
  regular: "NotoSansDevanagari-Regular",
  bold: "NotoSansDevanagari-Bold",
  extraBold: "NotoSansDevanagari-ExtraBold",
  black: "NotoSansDevanagari-Black",
};

export const fontSize = {
  _2xs: 10,
  xs: 12,
  sm: 14,
  base: 16,
  lg: 18,
  xl: 20,
  _2xl: 24,
  _3xl: 30,
  _4xl: 36,
  _5xl: 48,
  _6xl: 60,
};

export const variants = {
  blank: {
    fontFamily: fontFamily.regular,
  },
  entityHeading: {
    fontFamily: fontFamily.bold,
    fontSize: fontSize.base,
    lineHeight: 24,
    marginBottom: 10,
    paddingHorizontal: 16,
  },
  display1: {
    fontFamily: fontFamily.extraBold,
    fontSize: fontSize._6xl,
    fontWeight: "800",
    lineHeight: 80,
  },
  display2: {
    fontFamily: fontFamily.bold,
    fontSize: fontSize._5xl,
    lineHeight: 72,
  },
  heading_30: {
    fontFamily: fontFamily.bold,
    fontSize: fontSize._3xl,
    lineHeight: 38,
  },
  heading_24: {
    fontFamily: fontFamily.bold,
    fontSize: fontSize._2xl,
    lineHeight: 36,
  },
  title_44: {
    fontFamily: fontFamily.black,
    fontSize: 44,
    lineHeight: 50,
  },
  title_20: {
    fontFamily: fontFamily.bold,
    fontSize: fontSize.xl,
    lineHeight: 30,
  },
  title_18: {
    fontFamily: fontFamily.bold,
    fontSize: fontSize.lg,
    lineHeight: 28,
  },
  title_18_semi: {
    fontFamily: fontFamily.semiBold,
    fontSize: fontSize.lg,
    lineHeight: 28,
  },
  title_18_regular: {
    fontFamily: fontFamily.regular,
    fontSize: fontSize.lg,
    lineHeight: 28,
  },
  subtitle_20: {
    fontFamily: fontFamily.semiBold,
    fontSize: fontSize.xl,
    lineHeight: 24,
  },
  title_16: {
    fontFamily: fontFamily.bold,
    fontSize: fontSize.base,
    lineHeight: 24,
  },
  subtitle_16: {
    fontFamily: fontFamily.semiBold,
    fontSize: fontSize.base,
    lineHeight: 24,
  },
  body_text_1: {
    fontFamily: fontFamily.regular,
    fontSize: fontSize.base,
    lineHeight: 24,
  },
  body_text_2: {
    fontFamily: fontFamily.bold,
    fontSize: fontSize.sm,
    lineHeight: 20,
  },
  body_text_3: {
    fontFamily: fontFamily.regular,
    fontSize: fontSize.sm,
    lineHeight: 18,
  },
  body_text_4: {
    fontFamily: fontFamily.semiBold,
    fontSize: fontSize.sm,
    lineHeight: 20,
  },
  caption_1: {
    fontFamily: fontFamily.bold,
    fontSize: fontSize.xs,
    lineHeight: 21,
  },
  caption_2: {
    fontFamily: fontFamily.regular,
    fontSize: fontSize.xs,
    lineHeight: 16,
  },
  caption_3: {
    fontFamily: fontFamily.regular,
    fontSize: fontSize._2xs,
    lineHeight: 14,
  },
  caption_4: {
    fontFamily: fontFamily.semiBold,
    fontSize: fontSize.xs,
    lineHeight: 16,
  },
};

export const getVariants = (variant, newfont) => {
  return variants[variant];
};
